// extracted by mini-css-extract-plugin
export var closeButton = "_jj-1";
export var closeX = "_jj-3";
export var container = "_jj-0";
export var image = "_jj-2";